import React from 'react';
import './Dashboard.css';
function Dashboard() {
  return (
    <div className="dashboard-container">
      <h1>Dashboard</h1>
      <div className="stats">
        <div className="stat-item">
          <h2>34</h2>
          <p>Open Tasks</p>
        </div>
        <div className="stat-item">
          <h2>76%</h2>
          <p>Project Completion</p>
        </div>
        {/* Add more stats or information as needed */}
      </div>
      {/* Additional sections like charts or tables could go here */}
    </div>
  );
}

export default Dashboard;
